<div class="container-fluid">
	<div class="row tile-grid">
		<video-tile *ngFor="let video of playlist.videos" class="col-xl-2 col-lg-3 col-sm-4 col-tablet-sm-6 col-xs-12" [video]="video" [playlist]="playlist" [mediaFeatures]="mediaFeatures" [hasMediaEditAuth]="hasMediaEditAuth" [userId]="userId">
		</video-tile>
	</div>
</div>
